import { logger } from '@/util/logger';

import Queue from '../modules/queue.js';

// Shortcut for working with some aspects of asp.net's PageRequestManager
let _instance;
function _attachEnqueuedHandlers() {
	_instance.add_beginRequest(function() {
		brQueue.run.call(brQueue);
	});
	_instance.add_endRequest(function() {
		erQueue.run.call(erQueue);
	});
}

export let erQueue = new Queue('erQueue');
export let brQueue = new Queue('brQueue');
export function getInstance() {
	return _instance;
}
export function init() {
	// if no update panels on this page, no need to continue. also return if WebForms or PageRequestManager is not present for any reason (e.g. script load failure)
	// condense above to a single statement 
	if (typeof window.Sys?.WebForms?.PageRequestManager === 'undefined') {
		return;
	}

	// get PageRequestManager instance
	// return if webforms
	_instance = window.Sys.WebForms.PageRequestManager.getInstance();

	// This handler is added to work around an issue where if an AJAX request is in-flight 
	// and the user clicks on a link that is not part of the UpdatePanel, an "unspecified" error occurs. 
	// This handler will catch that error and prevent the pop-up from showing, allowing the browser to 
	// respond to the second request as expected.
	// see stackoverflow discussion for more details: http://stackoverflow.com/questions/1271176/sys-webforms-pagerequestmanagerservererrorexception
	Sys.WebForms.PageRequestManager.getInstance().add_endRequest(customEndRequestHandler);
	function customEndRequestHandler(sender, args) {
		const error = args.get_error();
		if (typeof error === 'undefined' || error === null) {
			return;
		}

		const response = args.get_response();
		const statusCode = response ? response.get_statusCode() : -1;

		if (statusCode !== 0) {
			logger.error('PageRequestManager endRequest error', {
				statusCode,
				message: error.message,
				error,
			});
		}

		args.set_errorHandled(true);
	}

	// attach all handlers enqueued before window load
	_attachEnqueuedHandlers();
}